import React, { useState, ReactNode, useContext } from "react";
import { Checkbox } from "antd";
import "./common.less";
import "./Header.less";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { notUseJoySpaceOffline } from "@/components/Joyspace/util";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext from "@/context/GlobalContext";

export enum JustifyContent {
  Left = "start",
  Center = "center",
  Right = "flex-end"
}

export interface ColumnsItem {
  title: string;
  dataIndex: string;
  key: string;
  render?: (item: ColumnsItem) => ReactNode;
  width?: number | string;
  style?: object;
  ellipsis?: boolean;
  justifyContent?: JustifyContent; // left center right
  checkbox?: boolean;
  actions?: boolean;
  filters?: boolean;
  disabled?: boolean;
}

interface IProps {
  disabledHeader: boolean;
  columns: ColumnsItem[];
  onCheckAllChange?: (e: CheckboxChangeEvent) => void;
  indeterminate?: boolean;
  checkAll?: boolean;
  from?: string;
  isRoot?: boolean;
}

const Header = (props: IProps) => {
  const {
    // disabledHeader = false,
    columns,
    indeterminate = false,
    checkAll = false,
    onCheckAllChange,
    from = "",
    isRoot = true
  } = props;
  const { onLine } = useContext(GlobalContext);

  // console.log(columns, 'columnscolumnscolumnscolumnscolumnscolumnscolumns');
  return (
    <div
      className={
        !notUseJoySpaceOffline() && !onLine ? "header-list header-item-disabled" : "header-list"
      }
      style={{ top: isRoot ? 40 : 0 }}
    >
      {columns?.map((item: ColumnsItem) => {
        return (
          <div
            className="joyspace-list-td header-item"
            style={{
              width: item.width || "auto",
              justifyContent: (item as any).justifyContent || JustifyContent.Left,
              flex: item.width && "initial",
              ...item.style
            }}
            key={item.key}
          >
            {item.checkbox && (
              <Checkbox
                indeterminate={indeterminate}
                onChange={(e: CheckboxChangeEvent) => {
                  // console.log(e, '=======');
                  onCheckAllChange?.(e);
                }}
                checked={checkAll}
                disabled={item.disabled && !notUseJoySpaceOffline()}
              />
            )}
            {item.title}
            {item.filters && item?.render?.(item)}
          </div>
        );
      })}
    </div>
  );
};

export default Header;
